import axios from "axios";

const storefrontProxyUrl = process.env.REACT_APP_STOREFRONT_PROXY_URL;

export async function getProductByID(productID) {
    const result = {success: false, product: null};
    // Get product basic details
    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products`, {
        params: {id: productID, include_fields: 'name,sku,inventory_level,categories,custom_url,is_visible'},
        headers: {'Accept': 'application/json'}
    }).then(response => {
        result.success = response.status === 200;
        result.product = response.data.data[0];
    }).catch(console.error);

    return result;
}

export async function getProductDetailsByID(productID) {
    const result = getProductByID(productID);
    if (result.product) {
        // Get product images
        await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productID}/images`, {
            params: {exclude_fields: 'product_id,description,image_file,url_zoom,url_standard,date_modified'},
            headers: {'Accept': 'application/json'}
        }).then(response => {
            const images = response.data.data;
            images.forEach((image) => {
                if (image.is_thumbnail) {
                    result.product.thumbnail_image_url = image.url_thumbnail;
                    result.product.tiny_image_url = image.url_tiny;
                }
            });
        }).catch(console.error);
    }

    return result;
}

/*export async function getProductDetailsBySKU(productSku) {
    let product;
    // Get product basic details
    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products`, {
        params: {sku: productSku, include_fields: 'name,sku,inventory_level,categories,is_visible'},
        headers: AUTH_HEADER
    }).then(response => {
        product = response.data.data[0];
    }).catch(console.error);

    if (product) {
        product.stock = product.inventory_level;
        delete product.inventory_level;
        // Get product images
        await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${product.id}/images`, {
            params: {exclude_fields: 'product_id,description,image_file,url_zoom,url_standard,date_modified'},
            headers: AUTH_HEADER
        }).then(response => {
            const images = response.data.data;
            images.forEach((image) => {
                if (image.is_thumbnail) {
                    product.thumbnail_image_url = image.url_thumbnail;
                    product.tiny_image_url = image.url_tiny;
                }
            });
        }).catch(console.error);
    }

    return product;
}*/

export async function getProductDataBySKUs(productSKUs) {
    let products = [];
    // Get product basic details
    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products`, {
        params: {'sku:in': productSKUs, include_fields: 'name,sku,price,inventory_level,categories,custom_url,is_visible', limit: 100},
        headers: {'Accept': 'application/json'}
    }).then(response => {
        products = response.data.data;
    }).catch(console.error);

    if (products) {
        products.forEach((product) => {
            product.stock = product.inventory_level;
            delete product.inventory_level;
        });
    }

    return products;
}

export async function getProductThumbnailImage(productID) {
    const productImages = {};
    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productID}/images`, {
        params: {exclude_fields: 'product_id,description,image_file,url_zoom,url_standard,date_modified'},
        headers: {'Accept': 'application/json'}
    }).then(response => {
        const images = response.data.data;
        images.forEach((image) => {
            if (image.is_thumbnail) {
                productImages.thumbnail_image_url = image.url_thumbnail;
                productImages.tiny_image_url = image.url_tiny;
            }
        });
    }).catch(console.error);

    return productImages;
}

export async function searchPrimaryProducts(searchKeyword, limit, page) {
    let result = {data: [], totalItems: 0};

    const apiParams = {
        'sku:in': '',
        include_fields: 'name,categories,is_visible',
        sort: 'date_modified',
        direction: 'desc',
        limit: limit,
        page: page
    };
    if (searchKeyword.trim() !== '')
        apiParams.keyword = searchKeyword.trim();

    // Get product basic details
    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products`, {
        params: apiParams,
        headers: {'Accept': 'application/json'}
    }).then(response => {
        result.data = response.data.data;
        result.totalItems = response.data.meta.pagination.total;
        if (result.data) {
            // Add stock property with 0
            result.data.forEach((product) => {
                product.stock = 0;
            });
        }
    }).catch(console.error);

    // Get product images
    if (result.data) {
        for (const product of result.data) {
            await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${product.id}/images`, {
                params: {exclude_fields: 'product_id,description,image_file,url_zoom,url_standard,date_modified'},
                headers: {'Accept': 'application/json'}
            }).then(response => {
                const images = response.data.data;
                images.forEach((image) => {
                    if (image.is_thumbnail) {
                        product.thumbnail_image_url = image.url_thumbnail;
                        product.tiny_image_url = image.url_tiny;
                    }
                });
            }).catch(console.error);
        }
    }

    return result;
}

export async function searchSecondaryProducts(searchKeyword, categories, limit, page) {
    let result = {data: [], totalItems: 0};

    const apiParams = {
        'sku:not_in': '',
        //is_visible: true,
        include_fields: 'name,sku,inventory_level,categories,is_visible',
        sort: 'sku', //date_modified
        direction: 'asc', //desc
        limit: limit,
        page: page
    };
    if (searchKeyword.trim() !== '')
        apiParams.keyword = searchKeyword.trim();
    if (categories.length !== 0)
        apiParams['categories:in'] = categories.toString();

    // Get product basic details
    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products`, {
        params: apiParams,
        headers: {'Accept': 'application/json'}
    }).then(response => {
        result.data = response.data.data;
        result.totalItems = response.data.meta.pagination.total;
        if (result.data) {
            // Remove result with no SKU --ALREADY DONE FROM QUERY
            //result = result.filter(product => (product.sku && product.sku !== ""));
            result.data.forEach((product) => {
                // Rename inventory_level to stock
                product.stock = product.inventory_level;
                delete product.inventory_level;
            });
        }
    }).catch(console.error);

    return result;
}

export async function createProduct(productName, productType, productBrandID, categories, description, customFields, searchKeywords, pageTitle, metaKeywords, metaDescription) {
    let result = {error: true, message: "Unable to create the product in Storefront.", data: {}};

    // Remove all empty Custom Fields
    customFields = customFields.filter(field => field.name.toString().trim() !== '');

    await axios.post(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products`, {
        'name': productName.trim(),
        'type': productType,
        'price': 0,
        'brand_id': productBrandID ? productBrandID : null,
        'weight': 0,
        'categories': categories,
        'description': description.trim(),
        'inventory_tracking': 'product',
        'inventory_level': 1,
        'custom_fields': customFields,
        'search_keywords': searchKeywords.trim(),
        'page_title': pageTitle.trim(),
        'meta_keywords': metaKeywords.trim().split(',').filter(keyword => keyword.toString().trim() !== ''),
        'meta_description': metaDescription.trim(),
        'is_visible': false
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(response => {
        if (response.data.data) {
            result.error = false;
            result.data.id = response.data.data.id;
        } else if ((response.status && response.status !== 200) || response.errors) {
            result.message = response.title || response.errors.title;
        }
    }).catch(console.error);

    return result;
}

export async function updateProductPrice(productId, price) {
    let result = {error: true, message: "Unable to update the product Price in Storefront.", data: {}};

    await axios.put(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productId}`, {
        'price': price
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(response => {
        if (response.data.data) {
            result.error = false;
            result.data.id = response.data.data.id;
        } else if ((response.status && response.status !== 200) || response.errors) {
            result.message = response.title || response.errors.title;
        }
    }).catch(console.error);

    return result;
}
export async function updateProductVisibility(productId, isVisible) {
    let result = {error: true, message: "Unable to update the product Visibility in Storefront.", data: {}};

    await axios.put(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productId}`, {
        'is_visible': isVisible
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(response => {
        if (response.data.data) {
            result.error = false;
            result.data.id = response.data.data.id;
        } else if ((response.status && response.status !== 200) || response.errors) {
            result.message = response.title || response.errors.title;
        }
    }).catch(console.error);

    return result;
}
export async function updateProductCustomFields(productId, customFields) {
    let result = {error: true, message: "Unable to update the product Custom Fields in Storefront.", data: {}};

    // Remove all empty Custom Fields
    customFields = customFields.filter(field => field.name.toString().trim() !== '');

    await axios.put(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productId}`, {
        'custom_fields': customFields
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(response => {
        if (response.data.data) {
            result.error = false;
            result.data.id = response.data.data.id;
        } else if ((response.status && response.status !== 200) || response.errors) {
            result.message = response.title || response.errors.title;
        }
    }).catch(console.error);

    return result;
}

export async function createProductImages(productID, imageFiles) {
    let result = true;

    for (const imageFile of imageFiles) {
        const index = imageFiles.indexOf(imageFile);
        await axios.post(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productID}/images`, {
            'product_id': productID,
            'is_thumbnail': index === 0,
            'sort_order': index,
            'image_file': imageFile
        }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
            // eslint-disable-next-line no-loop-func
        }).then(response => {
            if (!response.data.data || !response.data.data.id)
                result = false;
        }).catch(console.error);

        if (!result)
            break;
    }

    return result;
}

export async function createProductImagesFromURL(productID, imageURL) {
    let result = true;

    await axios.post(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productID}/images`, {
        'product_id': productID,
        'is_thumbnail': true,
        'sort_order': 0,
        'image_url': imageURL
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(response => {
        if (!response.data.data || !response.data.data.id)
            result = false;
    }).catch(console.error);

    return result;
}

export async function getAllProductOptions(productID) {
    const result = {success: false, options: null};
    // Get product basic details
    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productID}/options`, {
        params: {include_fields: 'id,display_name,name,sort_order,option_values'},
        headers: {'Accept': 'application/json'}
    }).then(response => {
        result.success = response.status === 200;
        result.options = response.data.data;
    }).catch(console.error);

    return result;
}

export async function getAllProductVariants(productID) {
    const result = {success: false, variants: null};
    // Get product basic details
    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productID}/variants`, {
        params: {include_fields: 'id,sku,option_values'},
        headers: {'Accept': 'application/json'}
    }).then(response => {
        result.success = response.status === 200;
        result.variants = response.data.data;
    }).catch(console.error);

    return result;
}

export async function createProductVariant(productID, variantInfo, optionValues) {
    let result = true;

    await axios.post(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productID}/variants`, {
        'cost_price': variantInfo.cost_price,
        'price': variantInfo.price,
        'sale_price': variantInfo.sale_price,
        'retail_price': variantInfo.retail_price,
        'weight': variantInfo.weight,
        'width': variantInfo.width,
        'height': variantInfo.height,
        'depth': variantInfo.depth,
        'is_free_shipping': variantInfo.is_free_shipping,
        'fixed_cost_shipping_price': variantInfo.fixed_cost_shipping_price,
        'purchasing_disabled': false,
        //'purchasing_disabled_message': null,
        'upc': variantInfo.upc,
        'inventory_level': 10000,
        'inventory_warning_level': 5,
        'bin_picking_number': variantInfo.bin_picking_number,
        //'image_url': null,
        'gtin': variantInfo.gtin,
        'mpn': variantInfo.mpn,
        'product_id': 0,
        'sku': variantInfo.sku + '-1',
        'option_values': optionValues
    }, {
        headers: {
            'Content-Type': 'application/json'
        }
    }).then(response => {
        if (!response.data.data || !response.data.data.id)
            result = false;
    }).catch(console.error);

    return result;
}

export async function deleteProductVariant(productID, variantID) {
    await axios.delete(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products/${productID}/variants/${variantID}`, {
        headers: {'Accept': 'application/json'}
    }).then().catch(console.error);
}

export async function getInventoryBySKU(skuArray) {
    let stock = 0;

    await axios.get(`${storefrontProxyUrl}/${localStorage.getItem('store_hash')}/products`, {
        params: {'sku:in': skuArray.toString(), include_fields: 'sku,inventory_level,is_visible', limit: 100},
        headers: {'Accept': 'application/json'}
    }).then(response => {
        const products = response.data.data;
        products.forEach((product) => {
            stock += product.inventory_level;
        })
    }).catch(console.error);

    return stock;
}